module.exports = __webpack_public_path__ + "67b43f55f450ffce2cb7b549704cbcfc.svg";